import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Página não encontrada (404) | Mesamind</title>
        <meta name="description" content="A página que você procura não existe ou foi movida. Volte ao início da Mesamind." />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href={`https://sociosconciliados.mesamind.com${location.pathname}`} />
        <meta property="og:title" content="Página não encontrada (404) | Mesamind" />
        <meta property="og:description" content="A página que você procura não existe ou foi movida." />
        <meta property="og:url" content={`https://sociosconciliados.mesamind.com${location.pathname}`} />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
